'use strict';

var _regeneratorRuntime = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var dagPB = require('ipld-dag-pb');

var dagCBOR = require('ipld-dag-cbor');

var raw = require('ipld-raw');

var multicodec = require('multicodec');

var noop = function noop() {};
/**
 * @typedef {import('cids')} CID
 */

/**
 * Return an object containing supported IPLD Formats
 *
 * @param {object} [options] - IPLD options passed to the http client constructor
 * @param {Array} [options.formats] - A list of IPLD Formats to use
 * @param {Function} [options.loadFormat] - An async function that can load a format when passed a codec number
 * @returns {Function}
 */


module.exports = function () {
  var _configuredFormats;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$formats = _ref.formats,
      formats = _ref$formats === void 0 ? [] : _ref$formats,
      _ref$loadFormat = _ref.loadFormat,
      loadFormat = _ref$loadFormat === void 0 ? noop : _ref$loadFormat;

  formats = formats || [];
  loadFormat = loadFormat || noop;
  var configuredFormats = (_configuredFormats = {}, _defineProperty(_configuredFormats, multicodec.DAG_PB, dagPB), _defineProperty(_configuredFormats, multicodec.DAG_CBOR, dagCBOR), _defineProperty(_configuredFormats, multicodec.RAW, raw), _configuredFormats);
  formats.forEach(function (format) {
    configuredFormats[format.codec] = format;
  });
  /**
   * Attempts to load an IPLD format for the passed CID
   *
   * @param {import('multicodec').CodecName} codec - The code to load the format for
   * @returns {Promise<object>} - An IPLD format
   */

  var loadResolver = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(codec) {
      var number, format;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // @ts-ignore - codec is a string and not a CodecName
              number = multicodec.getNumber(codec);
              _context.t0 = configuredFormats[number];

              if (_context.t0) {
                _context.next = 6;
                break;
              }

              _context.next = 5;
              return loadFormat(codec);

            case 5:
              _context.t0 = _context.sent;

            case 6:
              format = _context.t0;

              if (format) {
                _context.next = 9;
                break;
              }

              throw Object.assign(new Error("Missing IPLD format \"".concat(codec, "\"")), {
                missingMulticodec: codec
              });

            case 9:
              return _context.abrupt("return", format);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function loadResolver(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return loadResolver;
};